import { useCallback, useState } from "react";
import { createQuizMachine } from "../stateMachine";
export const useQuizState = () => {
    const [machine] = useState(() => createQuizMachine());
    const [state, setState] = useState(() => ({
        value: machine.value,
        context: machine.context,
    }));
    const initializeState = useCallback(async (hasConsent) => {
        if (hasConsent === null) {
            return;
        }
        try {
            machine.initialize(hasConsent);
            if (hasConsent) {
                const result = await machine.transition({ type: "CONSENT_GIVEN" });
                setState(result);
            }
            else {
                setState({
                    value: machine.value,
                    context: machine.context,
                });
            }
        }
        catch (error) {
            console.error("[DEBUG] Failed to initialize the quiz state:", error);
        }
    }, [machine]);
    const handleAnswer = useCallback(async (answer) => {
        try {
            const result = await machine.transition({
                type: "ANSWER",
                payload: answer,
            });
            setState(result);
            return result;
        }
        catch (error) {
            console.error("Failed to handle answer:", error);
            return null;
        }
    }, [machine]);
    const completeQuiz = useCallback(async () => {
        try {
            const result = await machine.transition({ type: "COMPLETE" });
            setState(result);
            return result;
        }
        catch (error) {
            console.error("Failed to complete quiz:", error);
            return null;
        }
    }, [machine]);
    return {
        state,
        machine,
        initializeState,
        handleAnswer,
        completeQuiz,
    };
};
//# sourceMappingURL=useQuizState.js.map